//#region src/core/Transport.ts
var e = class {
	config;
	messageHandlers = /* @__PURE__ */ new Set();
	originValidator;
	messageListener;
	constructor(e) {
		this.config = e, this.originValidator = this.createOriginValidator(e.origin), this.messageListener = this.handleMessage.bind(this), this.initListener();
	}
	send(e, t) {
		let n = typeof this.config.origin == "string" && this.config.origin !== "*" ? this.config.origin : "*";
		this.config.debug && console.log(`[Linker Transport] Sending message to ${n}:`, t), t.source = "linker", e.postMessage(t, n);
	}
	onMessage(e) {
		return this.messageHandlers.add(e), () => this.messageHandlers.delete(e);
	}
	initListener() {
		window.addEventListener("message", this.messageListener);
	}
	handleMessage(e) {
		if (!this.originValidator(e.origin)) {
			this.config.debug && console.warn(`[Linker Transport] Rejected message from untrusted origin: ${e.origin}`);
			return;
		}
		let t = e.data;
		!t || typeof t.type != "string" || t.source === "linker" && (this.config.debug && console.log(`[Linker Transport] Received message from ${e.origin}:`, t), this.messageHandlers.forEach((e) => e(t)));
	}
	createOriginValidator(e) {
		return e === "*" ? () => !0 : typeof e == "string" ? (t) => t === e : Array.isArray(e) ? (t) => e.includes(t) : e instanceof RegExp ? (t) => e.test(t) : typeof e == "function" ? e : () => !1;
	}
	destroy() {
		this.messageHandlers.clear(), window.removeEventListener("message", this.messageListener);
	}
}, t = "1.0.11", n = /* @__PURE__ */ function(e) {
	return e.ELEMENT_SELECTED = "ELEMENT_SELECTED", e.MODIFY_TEXT = "MODIFY_TEXT", e.PING = "PING", e.PONG = "PONG", e.ACTIVATE = "ACTIVATE", e.DEACTIVATE = "DEACTIVATE", e;
}({}), r = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", i = (e = 21) => {
	let t = "", n = crypto.getRandomValues(new Uint8Array(e |= 0));
	for (; e--;) t += r[n[e] & 63];
	return t;
}, a = class {
	transport;
	config;
	plugins = /* @__PURE__ */ new Map();
	hooks;
	constructor(t, n = {}) {
		this.config = t, this.hooks = n, this.transport = new e(t), this.hooks.onInit?.(), this.config.debug && console.log("[Linker Core] Initialized");
	}
	use(e) {
		return this.plugins.has(e.name) ? (console.warn(`[Linker Core] Plugin "${e.name}" is already registered.`), this) : (this.plugins.set(e.name, e), e.install(this), this.config.debug && console.log(`[Linker Core] Plugin "${e.name}" installed.`), this);
	}
	send(e, t = {}) {
		let n = {
			type: e,
			data: t,
			timestamp: Date.now(),
			id: i()
		};
		this.hooks.beforeSend?.(n), this.transport.send(window.parent, n);
	}
	on(e, t) {
		return this.transport.onMessage((n) => {
			n.type === e && (this.hooks.afterReceive?.(n), t(n.data));
		});
	}
	start() {
		this.send(n.PING), this.hooks.onConnect?.();
	}
	getConfig() {
		return { ...this.config };
	}
	destroy() {
		this.transport.destroy(), this.hooks.onDestroy?.(), this.plugins.clear();
	}
};
//#endregion
//#region src/parent.ts
typeof window < "u" && console.log(`%c Linker Parent SDK v${t} %c`, "background: #24292e; color: #fff; border-radius: 3px; padding: 2px 5px;", "");
function o(t, n = {}) {
	let r = new e({
		origin: n.origin || "*",
		debug: n.debug || !1
	});
	return {
		send: (e, n) => {
			if (t.contentWindow) {
				let i = {
					type: e,
					data: n,
					timestamp: Date.now(),
					id: Math.random().toString(36).substring(2, 11)
				};
				r.send(t.contentWindow, i);
			}
		},
		on: (e, t) => r.onMessage((n) => {
			n.type === e && t(n.data);
		}),
		destroy: () => {
			r.destroy();
		}
	};
}
//#endregion
export { a as Linker, n as MessageType, e as Transport, o as createLinkerHost };

//# sourceMappingURL=linker-parent.es.femf3n5t.js.map